/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgAppsGrid = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M3 3h4v4H3V3zm0 14h4v4H3v-4zm1-7H3v4h4v-4H4zm13-7h4v4h-4V3zm1 14h-1v4h4v-4h-3zm-1-7h4v4h-4v-4zm-6-7h-1v4h4V3h-3zm-1 14h4v4h-4v-4zm1-7h-1v4h4v-4h-3z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgAppsGrid as AppsGrid };
